module.exports = "./images/14_pariticosmetic.jpg";